import { getNoContentApiClient } from 'adapter/out/client/apiClient';
import DeleteStoredAnalysisCriteria from 'use-case/storedAnalysis/delete/deleteStoredAnalysisCriteria';

const deleteStoredAnalysisApiClient = getNoContentApiClient(
    (criteria: DeleteStoredAnalysisCriteria) => `dashboards/stored-analyses/${criteria.storedAnalysisId}`,
    () => ({
        method: 'DELETE',
        body: undefined,
        headers: { 'Content-Type': 'application/json' },
    })
);

export default deleteStoredAnalysisApiClient;
